export default {
  init() {
    // JavaScript to be fired on the home page
    jQuery(function ($) {
      $('#get-afr-certified').click(function(e) {
        ga('send', 'event', 'Internal Clicks', 'Clicked Get AFR Certified', 'Button in Training Webinars page');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/trainingwebinars.js